import { Input, InputProps } from '@chakra-ui/react';
import MaskedInput, {
  MaskedInputProps as ReactTextMaskedInputProps,
} from 'react-text-mask';

interface MaskedInputProps extends InputProps {
  label?: string;
  masking: ReactTextMaskedInputProps['mask'];
}

export function MaskedInputField({
  label,
  masking,
  children,
  ...props
}: MaskedInputProps) {
  return (
    <Input
      as={MaskedInput}
      aria-label={label}
      mask={masking}
      fontWeight="semibold"
      textAlign="center"
      variant="unstyled"
      {...props}
    />
  );
}

export default MaskedInputField;
